const elementInView = (el, dividend = 1) => {
  const elementTop = el.getBoundingClientRect().top;

  return (
    elementTop <=
    (window.innerHeight || document.documentElement.clientHeight) / dividend
  );
};

const elementOutofView = (el) => {
  const elementTop = el.getBoundingClientRect().top;

  return (
    elementTop > (window.innerHeight || document.documentElement.clientHeight)
  );
};

const displayScrollElement = (element) => {
  element.classList.add("animate__animated");
};

const hideScrollElement = (element) => {
  element.classList.remove("animate__animated");
};

const handleScrollAnimation = () => {
  window.scrollElements.forEach((el) => {    
    if (elementInView(el, 1.25)) {
      displayScrollElement(el);
    } else if (elementOutofView(el)) {
      hideScrollElement(el)
    }
  })
}

window.scrollElements = [];
window.addEventListener("load", () => { 
  window.scrollElements = document.querySelectorAll(".animate-scroll");
});

window.addEventListener("scroll", () => { 
  handleScrollAnimation();
});
